var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{attrs:{"xs12":"","sm4":"","md3":"","lg2":""}},[_c('a',{class:_vm.b(),attrs:{"href":_vm.file.file,"target":"_blank"}},[_c('div',{class:_vm.b('icon')},[_c('v-icon',[_vm._v(_vm._s(_vm.fileIcon))])],1),_c('div',{class:_vm.b('name')},[_vm._v(_vm._s(_vm.file.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }